function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M7.016.53A.895.895 0 0 1 7.53.058c.226-.079.451-.079.677 0a.895.895 0 0 1 .514.47l1.912 3.883 4.294.617c.255.04.456.157.603.353a.983.983 0 0 1 .206.647.903.903 0 0 1-.28.618l-3.117 3.03.735 4.294a.929.929 0 0 1-.132.661.864.864 0 0 1-.544.397.907.907 0 0 1-.677-.088l-3.852-2-3.853 2a.907.907 0 0 1-.677.088.864.864 0 0 1-.544-.397.929.929 0 0 1-.132-.661l.735-4.295L.28 6.647A.903.903 0 0 1 0 6.029a.983.983 0 0 1 .207-.647.892.892 0 0 1 .603-.353l4.294-.617L7.016.529z"
}));

var _ref3 = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4 4)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("use", {
  fill: "#004152",
  xlinkHref: "#a"
}), React.createElement("g", {
  fill: "#004152",
  mask: "url(#b)"
}, React.createElement("path", {
  d: "M-3.765-3.765h23v23h-23z"
})));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.1c5325f8.svg";
export { ForwardRef as ReactComponent };